import mutations from './emailView.mutations'
import actions from './emailView.actions'
import getters from './emailView.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
